import {createContext} from "react"
import { GebaeudeTyp } from "./state/types.ts"

export interface Config{
    client_name : string,
    client_display_name : string,
    modal_confirm_button_label : string,
    country : 'de' | 'at' | 'ch',
    base_asset_url : string,
    plz_validation : (plz : string) => boolean,
    plz_default: string,
    foerderung : boolean,
    building_geometry_api : boolean,
    uid?: string,
    contact_url?: string,
    logo_url?: string,
    menu_items_sorting?: Array<string>,
    plus_expanded?: boolean,
    show_geg_info: boolean,
    one_click_house_type: boolean,
    show_funding_list: boolean,
    development_mode: boolean,
    gebaeude_typ_options?: Array<GebaeudeTyp>,
}

export const ConfigContext = createContext<Config>({
    client_name : "febis",
    client_display_name : "Febis",
    modal_confirm_button_label : "übernehmen",
    country : 'at',
    base_asset_url :` https://esr.fe-bis.de/at/febis/`,
    plz_validation : (plz : string) => plz.length == 4,
    plz_default: "12345",
    foerderung : false,
    building_geometry_api : false,
    menu_items_sorting: undefined,
    plus_expanded: false,
    show_geg_info: true,
    one_click_house_type: false,
    show_funding_list: false,
    development_mode: false,
});


